import { ModelRow, StringUtil } from "@mcleod/core";
import { DataSourceMode, Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutReferenceNumberCompareItem } from "./autogen/AutogenLayoutReferenceNumberCompareItem";

export class ReferenceNumberCompareItem extends AutogenLayoutReferenceNumberCompareItem {
    private _compareItems: ModelRow[];

    override onLoad(): void | Promise<void> {
        this.tableCompareItems.dataSource = this.sourceEdiCompareItem;
    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
        if (this._compareItems != null)
            this.tableCompareItems.dataSource.setRowsAndMode(DataSourceMode.NONE, this._compareItems);

        if (this._compareItems != null && this._compareItems.length == 0) {
            this.tableCompareItems.visible = false;
        }
    }
    onRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelDescr = tableRow.findComponentById("labelDescr") as Label;
        if (StringUtil.isEmptyString(labelDescr.text)) {
            if (!StringUtil.isEmptyString(tableRow.data.get("source_value"))) {
                labelDescr.text = tableRow.data.get("source_descr");
            } else {
                labelDescr.text = tableRow.data.get("target_descr");
            }
        }
    }
}
